export const CHECKOUT_URL = 'https://flight-instructor-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/gWSyrE7zrUpXpP66RyTCUH/Diseno_sin_titulo_(70).png'

export const HERO_IMAGE_ALT =
  'Flight Instructor Ready complete system: Class Finder tablet, main book, 6 volumes, 150 ready-to-teach flight lessons and 5 professional bonus guides'

export const PRIMARY_CTA = 'GET FLIGHT INSTRUCTOR READY NOW'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 1 — Flight Foundations, Cockpit Familiarization & First Lessons' },
  { kind: 'included', label: 'Volume 2 — Aircraft Control, Aerodynamics & Core Flight Maneuvers' },
  { kind: 'included', label: 'Volume 3 — Takeoff, Traffic Patterns, Approach & Landing' },
  { kind: 'included', label: 'Volume 4 — Navigation, Radio Communication & Flight Planning' },
  { kind: 'included', label: 'Volume 5 — Weather, Risk Management & Emergency Decision-Making' },
  { kind: 'included', label: 'Volume 6 — 150 Ready-to-Teach Flight Lessons — Beginner to Checkride-Ready' },
  { kind: 'bonus', label: 'Flight Instructor Cueing & Error Correction Handbook' },
  { kind: 'bonus', label: '100 Flight Training Drills, Scenarios & Student Challenges' },
  { kind: 'bonus', label: 'Student Pilot Assessment & Progress Tracking System' },
  { kind: 'bonus', label: 'Flight Lesson Planning & Sequencing System' },
  { kind: 'bonus', label: 'Flight Training Troubleshooting & Problem-Solving Manual' },
  { kind: 'included', label: '100% Visual Teaching Material' },
  { kind: 'included', label: 'Immediate Digital Access' },
]
